/**
 * Storage that is responsible for keeping the references of the files attached to an e-mail.
 */
export class AttachmentStorage {
  private _files;

  constructor() {
    this._files = [];
  }

  /**
   * The list of the files attached to the current e-mail.
   * @returns {Array<File>} The array of the the attached File objects.
   */
  get files() {
    return this._files;
  }

  /**
   * Assigns the specified file attachment to the current e-mail.
   * @param {File} file - The attachment file to store.
   * @throws {Error} If the file is not specified.
   */
  addFile(file) {
    if (!file) {
      throw new Error('Please specify the file to add to the attachment storage!');
    }
    this._files.push(file);
  }

  /**
   * Removes the specified file from the attachments of the current e-mail.
   * @param {File} file - The attachment file to remove.
   * @throws {Error} If the file is not specified.
   */
  deleteFile(file) {
    if (!file) {
      throw new Error('Please specify the file to delete from the attachment storage!');
    }
    this._files.splice(this._files.indexOf(file), 1);
  }

  /**
   * Removes all previously specified file attachments from the current e-mail.
   */
  clear() {
    this._files = [];
  }

  /**
   * Returns whether there is no file attached to the current e-mail yet.
   * @returns {boolean} True, if there are no attachment files are assigned to the current e-mail yet.
   */
  isEmpty() {
    return this._files.length === 0;
  }
}
